export default __webpack_public_path__ + "static/media/LightOff.95efef1a.svg";